export default {"src":"/_next/static/media/Info-Icon.bf450fe9.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};